import React from 'react';
//Components
import moment from 'moment';
import TotalAnalysesOptions from './totalAnalysesOptions.jsx';
import TotalAnalysesSummary from './totalAnalysesSummary.jsx';
import Loader from '../../../../components/loader.jsx';
import {FormattedMessage} from 'react-intl';
import ReportSummaryErrorHandler from '../../components/reportSummaryErrorHandler';
import {makeCancelable} from 'helpers/cancelablePromise';
import ReportApi from '../../../../../api/report.jsx';

class TotalAnalyses extends React.Component {
  state = {
    data: [],
    filters: [],
    loaded: true,
    showNoDataMessage: false,
    error: false,
  };

  componentWillMount() {
    let date = new Date();
    let filters = {
      dateFrom: moment(new Date(date.setMonth(date.getMonth() - 1))),
      dateTo: moment(new Date()),
      store: 0,
      systemType: 0,
    };

    this.setState({
      filters: filters,
    });
  }

  updateReportData = (dateFrom, dateTo, branch, systemType) => {
    let filters = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      branch: branch,
      systemType: systemType,
    };

    this.setState({
      data: [],
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        data: [],
      });
    }

    (this.fetching = makeCancelable(ReportApi.getWaterTotalAnalyses(dateFrom, dateTo, branch, systemType)))
      .then(res => {
        if(res && res.Analyses > 0) {
          this.setState({
            data: res,
            filters: filters,
            showNoDataMessage: false,
          });
        } else {
          this.setState({showNoDataMessage: true});
        }
        this.setState({loaded: true});
      }).catch((e) => {
        console.log(e);
        this.setState({loaded: true,showNoDataMessage: true, error: true});
      });
  };

  render() {
    return (
      <div className="report-container">
        <span>
          <FormattedMessage id="reports.total.analyses.description" />
        </span>
        <TotalAnalysesOptions updateReportData={this.updateReportData} branches={this.props.branches} defaultFilters={this.state.filters} />
        <Loader loaded={this.state.loaded}>
          <ReportSummaryErrorHandler  error={this.state.error}>
            <TotalAnalysesSummary data={this.state.data}
                                  POSActive={this.props.POSActive}
                                  filters={this.state.filters}
                                  showNoDataMessage={this.state.showNoDataMessage}
                                  dealer={this.props.dealer}/>
          </ReportSummaryErrorHandler>
        </Loader>
      </div>
    );
  }
}

export default TotalAnalyses;
